import * as z from "zod";

const _cropConfigV2Schema = z.object({
  xRatio: z.number().min(0).max(1),
  yRatio: z.number().min(0).max(1),
  widthRatio: z.number().positive().max(1),
  heightRatio: z.number().positive().max(1),
  circularCrop: z.boolean(),
  baseImage: z.object({
    width: z.number().int().positive(),
    height: z.number().int().positive(),
  }),
});

export const cropConfigV2Schema: z.ZodType<CropConfigV2> = _cropConfigV2Schema;
export interface CropConfigV2 extends z.infer<typeof _cropConfigV2Schema> {}
